import { FeatureClass } from '../models';

export const featureClasses: FeatureClass[] = [
    {
        id: 'PPL',
        name: 'Populated place',
        description: 'A city, town, village, or other agglomeration of buildings where people live and work',
        order: 'a',
    },
    {
        id: 'PPLA',
        name: 'Seat of a first-order administrative division',
        description: 'Seat of a first-order administrative division (PPLC takes precedence over PPLA)',
        order: 'b',
    },
    {
        id: 'PPLA2',
        name: 'Seat of a second-order administrative division',
        order: 'c',
    },
    {
        id: 'PPLA3',
        name: 'Seat of a third-order administrative division',
        order: 'd',
    },
    {
        id: 'PPLA4',
        name: 'Seat of a fourth-order administrative division',
        order: 'e',
    },
    {
        id: 'PPLC',
        name: 'Capital of a political entity',
        order: 'f',
    },
    {
        id: 'PPLCH',
        name: 'Historical capital of a political entity',
        description: 'A former capital of a political entity',
        order: 'g',
    },
    {
        id: 'PPLF',
        name: 'Farm/village',
        description: 'A populated place where the population is largely engaged in agricultural activities',
        order: 'h',
    },
    {
        id: 'PPLG',
        name: 'Seat of government of a political entity',
        order: 'i',
    },
    {
        id: 'PPLH',
        name: 'Historical populated place',
        description: 'A populated place that no longer exists',
        order: 'j',
    },
    {
        id: 'PPLL',
        name: 'Populated locality',
        description: 'An area similar to a locality but with a small group of dwellings or other buildings',
        order: 'k',
    },
    {
        id: 'PPLQ',
        name: 'Abandoned populated place',
        order: 'l',
    },
    {
        id: 'PPLR',
        name: 'Religious populated place',
        description: 'A populated place whose population is largely engaged in religious occupations',
        order: 'm',
    },
    {
        id: 'PPLS',
        name: 'Populated places',
        description: 'Cities, towns, villages, or other agglomerations of buildings where people live and work',
        order: 'n',
    },
    {
        id: 'PPLW',
        name: 'Destroyed populated place',
        description: 'A village, town or city destroyed by a natural disaster, or by war',
        order: 'o',
    },
    {
        id: 'PPLX',
        name: 'Section of populated place',
        order: 'p',
    },
    {
        id: 'STLMT',
        name: 'Israeli settlement',
        order: 'q',
    },
    {
        id: 'ADM1',
        name: 'First-order administrative division',
        description: 'A primary administrative division of a country, such as a state, province, or region',
        order: 'z_0',
    },
    {
        id: 'ADM2',
        name: 'Second-order administrative division',
        description: 'A subdivision of a first-order administrative division',
        order: 'z_1',
    },
    {
        id: 'ADM3',
        name: 'Third-order administrative division',
        description: 'A subdivision of a second-order administrative division',
        order: 'z_2',
    },
    {
        id: 'ADM4',
        name: 'Fourth-order administrative division',
        description: 'A subdivision of a third-order administrative division',
        order: 'z_3',
    },
    {
        id: 'ADMD',
        name: 'Administrative division',
        description: 'An administrative division of a country, undifferentiated as to order',
        order: 'z_4',
    },
    {
        id: 'LTER',
        name: 'Leased territory',
        description: 'A tract of land leased to another country',
        order: 'z_5',
    },
    {
        id: 'PCL',
        name: 'Political entity',
        description: 'A political entity',
        order: 'z_6',
    },
    {
        id: 'PCLD',
        name: 'Dependent political entity',
        description: 'A dependent political entity',
        order: 'z_7',
    },
    {
        id: 'PCLF',
        name: 'Freely associated state',
        description: 'A freely associated state',
        order: 'z_8',
    },
    {
        id: 'PCLI',
        name: 'Independent political entity',
        description: 'An independent political entity',
        order: 'z_9',
    },
    {
        id: 'PCLIX',
        name: 'Section of independent political entity',
        description: 'A section of an independent political entity',
        order: 'z_10',
    },
    {
        id: 'PCLS',
        name: 'Semi-independent political entity',
        description: 'A semi-independent political entity',
        order: 'z_11',
    },
    {
        id: 'PRSH',
        name: 'Parish',
        description: 'An ecclesiastical or administrative division',
        order: 'z_12',
    },
    {
        id: 'TERR',
        name: 'Territory',
        description: 'A territory',
        order: 'z_13',
    },
    {
        id: 'ZN',
        name: 'Zone',
        description: 'A zone',
        order: 'z_14',
    },
    {
        id: 'ZNB',
        name: 'Buffer zone',
        description: 'A buffer zone',
        order: 'z_15',
    },
    {
        id: 'AIRP',
        name: 'Airport',
        description: 'A place where aircraft regularly land and take off',
        order: 'z_16',
    },
    {
        id: 'AMUS',
        name: 'Amusement park',
        description: 'An amusement park',
        order: 'z_17',
    },
    {
        id: 'ANS',
        name: 'Ancient site',
        description: 'A place where archeological remains, old structures, or cultural artifacts are located',
        order: 'z_18',
    },
    {
        id: 'AQUA',
        name: 'Aquarium',
        description: 'A facility where aquatic animals are kept for study or display',
        order: 'z_19',
    },
    {
        id: 'ARCH',
        name: 'Arch',
        description: 'A natural or man-made arch',
        order: 'z_20',
    },
    {
        id: 'BANK',
        name: 'Bank',
        description: 'A financial establishment',
        order: 'z_21',
    },
    {
        id: 'BCN',
        name: 'Beacon',
        description: 'A fixed signal used for navigation',
        order: 'z_22',
    },
    {
        id: 'BDG',
        name: 'Bridge',
        description: 'A structure erected across a river, road, railroad, etc.',
        order: 'z_23',
    },
    {
        id: 'BLDG',
        name: 'Building',
        description: 'A structure used for habitation, government, commerce, etc.',
        order: 'z_24',
    },
    {
        id: 'BRKS',
        name: 'Barracks',
        description: 'A building for lodging military personnel',
        order: 'z_25',
    },
    {
        id: 'BRKW',
        name: 'Breakwater',
        description: 'A structure protecting a shore area, harbor, anchorage, or basin from waves',
        order: 'z_26',
    },
    {
        id: 'BSTN',
        name: 'Baling station',
        description: 'A facility for baling hay, cotton, etc.',
        order: 'z_27',
    },
    {
        id: 'BTY',
        name: 'Battery',
        description: 'A fortification',
        order: 'z_28',
    },
    {
        id: 'BUR',
        name: 'Burial cave',
        description: 'A cave used for burial',
        order: 'z_29',
    },
    {
        id: 'CAVE',
        name: 'Cave',
        description: 'A natural underground chamber',
        order: 'z_30',
    },
    {
        id: 'CH',
        name: 'Church',
        description: 'A building for public Christian worship',
        order: 'z_31',
    },
    {
        id: 'CMP',
        name: 'Camp',
        description: 'A site occupied by tents, huts, or other shelters for temporary use',
        order: 'z_32',
    },
    {
        id: 'CNL',
        name: 'Canal',
        description: 'An artificial watercourse',
        order: 'z_33',
    },
    {
        id: 'CSTL',
        name: 'Castle',
        description: 'A large fortified building or set of buildings',
        order: 'z_34',
    },
    {
        id: 'CTRB',
        name: 'Control tower',
        description: 'A tower at an airfield from which air traffic is controlled',
        order: 'z_35',
    },
    {
        id: 'DAM',
        name: 'Dam',
        description: 'A barrier constructed to hold back water',
        order: 'z_36',
    },
    {
        id: 'DOCK',
        name: 'Dock',
        description: 'A waterway between two piers or wharves',
        order: 'z_37',
    },
    {
        id: 'EST',
        name: 'Estate',
        description: 'A large commercialized agricultural landholding',
        order: 'z_38',
    },
    {
        id: 'FCL',
        name: 'Facility',
        description: 'A building or place that provides a particular service',
        order: 'z_39',
    },
    {
        id: 'FNDY',
        name: 'Foundry',
        description: 'A workshop or factory for casting metal',
        order: 'z_40',
    },
    {
        id: 'FORT',
        name: 'Fort',
        description: 'A defensive structure or earthwork',
        order: 'z_41',
    },
    {
        id: 'GATE',
        name: 'Gate',
        description: 'A barrier for controlling passage',
        order: 'z_42',
    },
    {
        id: 'GDN',
        name: 'Garden',
        description: 'A plot of ground where herbs, fruits, flowers, or vegetables are cultivated',
        order: 'z_43',
    },
    {
        id: 'GHAT',
        name: 'Ghat',
        description: 'Steps leading down to a river',
        order: 'z_44',
    },
    {
        id: 'GLCR',
        name: 'Glacier',
        description: 'A slowly moving mass or river of ice',
        order: 'z_45',
    },
    {
        id: 'GRGE',
        name: 'Gorge',
        description: 'A narrow valley between hills or mountains',
        order: 'z_46',
    },
    {
        id: 'GYM',
        name: 'Gymnasium',
        description: 'A place for gymnastics and athletic exercises',
        order: 'z_47',
    },
    {
        id: 'HBR',
        name: 'Harbor',
        description: 'A sheltered port where ships can take on or discharge cargo',
        order: 'z_48',
    },
    {
        id: 'HSP',
        name: 'Hospital',
        description: 'An institution providing medical and surgical treatment',
        order: 'z_49',
    },
    {
        id: 'HTL',
        name: 'Hotel',
        description: 'A commercial establishment providing lodging',
        order: 'z_50',
    },
    {
        id: 'HUT',
        name: 'Hut',
        description: 'A small, simple dwelling or shelter',
        order: 'z_51',
    },
    {
        id: 'ISL',
        name: 'Island',
        description: 'A tract of land surrounded by water',
        order: 'z_52',
    },
    {
        id: 'LAKE',
        name: 'Lake',
        description: 'A large body of water surrounded by land',
        order: 'z_53',
    },
    {
        id: 'LIBR',
        name: 'Library',
        description: 'A place in which literary, musical, artistic, or reference materials are kept for use but not for sale',
        order: 'z_54',
    },
    {
        id: 'LNDF',
        name: 'Landfill',
        description: 'A site for the disposal of waste materials',
        order: 'z_55',
    },
    {
        id: 'LOCK',
        name: 'Lock',
        description: 'A device for raising and lowering boats between stretches of water of different levels on river and canal waterways',
        order: 'z_56',
    },
    {
        id: 'LTHS',
        name: 'Lighthouse',
        description: 'A tower or other structure containing a beacon light to warn or guide ships',
        order: 'z_57',
    },
    {
        id: 'MALL',
        name: 'Mall',
        description: 'A large enclosed shopping area',
        order: 'z_58',
    },
    {
        id: 'MFG',
        name: 'Factory',
        description: 'A building or group of buildings where goods are manufactured',
        order: 'z_59',
    },
    {
        id: 'MILE',
        name: 'Milestone',
        description: 'A stone marker giving the distance in miles',
        order: 'z_60',
    },
    {
        id: 'MILL',
        name: 'Mill',
        description: 'A building equipped with machinery for grinding grain',
        order: 'z_61',
    },
    {
        id: 'MINE',
        name: 'Mine',
        description: 'An excavation in the earth for extracting coal or other minerals',
        order: 'z_62',
    },
    {
        id: 'MKT',
        name: 'Market',
        description: 'A regular gathering of people for the purchase and sale of provisions, livestock, and other commodities',
        order: 'z_63',
    },
    {
        id: 'MON',
        name: 'Monument',
        description: 'A statue, building, or other structure erected to commemorate a famous or notable person or event',
        order: 'z_64',
    },
    {
        id: 'MSQE',
        name: 'Mosque',
        description: 'A Muslim place of worship',
        order: 'z_65',
    },
    {
        id: 'MSTY',
        name: 'Monastery',
        description: 'A building or buildings occupied by a community of monks living under religious vows',
        order: 'z_66',
    },
    {
        id: 'MT',
        name: 'Mountain',
        description: "A large natural elevation of the earth's surface rising abruptly from the surrounding level",
        order: 'z_67',
    },
    {
        id: 'MUS',
        name: 'Museum',
        description: 'A building in which objects of historical, scientific, artistic, or cultural interest are stored and exhibited',
        order: 'z_68',
    },
    {
        id: 'OBS',
        name: 'Observatory',
        description: 'A building or place equipped for observation of natural phenomena',
        order: 'z_69',
    },
    {
        id: 'OPRA',
        name: 'Opera house',
        description: 'A theatre used for the performance of operas',
        order: 'z_70',
    },
    {
        id: 'PAL',
        name: 'Palace',
        description: 'The official residence of a sovereign, archbishop, bishop, or other exalted person',
        order: 'z_71',
    },
    {
        id: 'PARK',
        name: 'Park',
        description: 'A large public garden or area of land used for recreation',
        order: 'z_72',
    },
    {
        id: 'PASS',
        name: 'Pass',
        description: 'A break in a mountain range or other high obstruction',
        order: 'z_73',
    },
    {
        id: 'PIER',
        name: 'Pier',
        description: 'A platform on pillars projecting from the shore into the sea',
        order: 'z_74',
    },
    {
        id: 'PKLT',
        name: 'Parking lot',
        description: 'An area where cars or other vehicles may be left temporarily',
        order: 'z_75',
    },
    {
        id: 'PO',
        name: 'Post office',
        description: 'A public department or corporation responsible for mail services',
        order: 'z_76',
    },
    {
        id: 'PORT',
        name: 'Port',
        description: 'A town or city with a harbor where ships load or unload',
        order: 'z_77',
    },
    {
        id: 'PP',
        name: 'Police post',
        description: 'A station or patrol point for police',
        order: 'z_78',
    },
    {
        id: 'PRK',
        name: 'Park',
        description: 'An area of open space provided for recreational use',
        order: 'z_79',
    },
    {
        id: 'PRSN',
        name: 'Prison',
        description: 'A building in which people are legally held as a punishment for a crime',
        order: 'z_80',
    },
    {
        id: 'PYR',
        name: 'Pyramid',
        description: 'A monumental structure with a square or triangular base and sloping sides that meet in a point at the top',
        order: 'z_81',
    },
    {
        id: 'QUAY',
        name: 'Quay',
        description: 'A stone or metal platform lying alongside or projecting into water for loading and unloading ships',
        order: 'z_82',
    },
];
